import { CanActivateFn } from '@angular/router';
import { UserAuthenticationService } from '../services/user-authentication/user-authentication.service';
import { inject } from '@angular/core';

export const AuthenticationGuard: CanActivateFn = async () => {

	const authService =  inject(UserAuthenticationService);

	let isAuthenticated = await authService.verifyIfUserIsAuthenticatedAsync();

	while(isAuthenticated === undefined){
		await new Promise(resolve => setTimeout(resolve, 500));
		isAuthenticated = await authService.verifyIfUserIsAuthenticatedAsync();
	}

	if(isAuthenticated){
		return true;
	}else{
		authService.redirectToLogin();
		return false;
	}
};
